import React from 'react'
import _ from 'lodash'
import { localizeTitle } from '~/tools/localization'

class NavLink extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = { isFocused: false }
    this.links = {}

    this.enableFocus = this.enableFocus.bind(this)
    this.disableFocus = this.disableFocus.bind(this)
    this.registerLinkRef = this.registerLinkRef.bind(this)
  }

  renderSubLinkMenu(links) {
    return (
      <div className="sublink-menu">
        { _.map(links, (link, idx) => (        
          <a 
            ref={ this.registerLinkRef(idx) } 
            onBlur={this.disableFocus} 
            key={ idx } 
            href={ link.url }
            target={ link.newTab ? "_blank" : "_self" }
          >
            { localizeTitle(link) }
          </a> 
        ))}
      </div>
    )
  }

  registerLinkRef(id) {
    return node => this.links[id] = node
  }

  enableFocus() {
    this.setState({ isFocused: true })
  }

  disableFocus() {
    setTimeout( () => {
      let shouldStayFocused = _.some(this.links, v => document.activeElement === v)
      this.setState({ isFocused: shouldStayFocused })
    }, 100)
  }

  render() {
    const { link } = this.props
    let style = {}
    if(link.icon){
       style = {
        backgroundImage: `url(${link.icon})`,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }
    }

    return(
      <div className={`primary-link ${link.icon? 'image-bg': ''} ${this.state.isFocused ? 'focused': ''}`} style={style}>
        <a 
          ref={ this.registerLinkRef('parent') } 
          onFocus={this.enableFocus} 
          onBlur={ this.disableFocus } 
          href={ link.url }
          target={ link.newTab ? "_blank" : "_self" }
        >
          { link.title }
        </a>

        { _.get(link, 'items.length') > 0 &&
          this.renderSubLinkMenu(link.items)
        }
      </div>
    )
  }
}

export default NavLink